export const TABS = {
  closed: 'closed',
  open: 'open',
  missing: 'missing',
} as const;
